import Image from 'app/Components/Shared/Image/image';
import React, { useState, useEffect } from 'react';
import { isMobile } from 'react-device-detect';
import { connect } from 'react-redux';
import Config from '../../../Config';
import { getReportParams, report } from '../../../middleware/report';

const SelfCareBanner = (props) => {

  const { worldType } = props;

  let bannerName = props.data.bannerName?.value;
  let bannerLink = props.data.bannerLink?.value;
  let imageDesktop = Config.epiBaseUrl + props.data.imageDesktop?.value?.url;
  let imageMobile = Config.epiBaseUrl + props.data.imageMobile?.value?.url;
  let externalLinkImageDesktop = Config.epiBaseUrl + props.data.externalLinkImageDesktop?.value?.url;
  let externalLinkImageMobile = Config.epiBaseUrl + props.data.externalLinkImageMobile?.value?.url;
  let pageLoadCounter = parseInt(sessionStorage.getItem('pageLoadCounter')) || 0;
  const imageUrl = pageLoadCounter > 3 ? (isMobile ? imageMobile : imageDesktop) : (isMobile ? externalLinkImageMobile : externalLinkImageDesktop);
  

  const handleBannerClick = () => {
    sendBannerReport();
    if (bannerLink) {
      window.open(bannerLink, '_blank');
    }
  };

  function sendBannerReport() {
    let reportParams = getReportParams();
    reportParams.area = 'SelfCare';
    reportParams.subArea = 'My Zone';
    reportParams.channel = 'WebsitePrivate';
    reportParams.actionType = `MyZone ${props.worldType} Lobby`; 
    reportParams.status = 'Ongoing';
    reportParams.messageText = 'Bunner Clicked';
    reportParams.param1 = bannerName;
    report(reportParams);
  }

  return (
    <div className='banner-container'>
      <div className={`banner-image-container ${bannerLink ? "cursor-pointer" : ""}`}>
        <Image src={imageUrl} alt="" onClick={handleBannerClick} />
      </div>
    </div>
  );
};

const mapStateToProps = (state) => {
  return {
    worldType: state.selfcarePage.epiData.worldType, 
  };
};

export default connect(mapStateToProps)(SelfCareBanner);